import angular from 'angular';
import { getPropOrDefault } from '../../tn.common';
import { DjangoLicenseType } from '../../tn.common/classes/Model/Licenses';
import { PopoverService } from '../../tn.popover/service.tn.popover';
import { allAreUnpaid } from '../has-license-type.filter/all-are-unpaid';
import { hasBeenPaid } from '../has-license-type.filter/has-been-paid';
import { hasFurtherUpgrades } from '../has-license-type.filter/has-further-upgrades';
import { hasLicenseType } from '../has-license-type.filter/has-license-type';
import { hasLimitedQty } from '../has-license-type.filter/has-limited-qty';
import { hasSelfHostedLicenseList } from '../has-license-type.filter/has-self-hosted-license-list';
import {
    IDjangoApi1License,
    LicenseService,
} from '../license.service/license-service';
import yourFontsListingTemplate from './your-fonts.html';

YourFonts.$inject = [
    'tnLicenseService',
    '$tnPopover',
];

export function YourFonts(
    licenseService: LicenseService,
    $tnPopover: PopoverService,
) {
    return {
        scope: {
            collection: '=',
            showApp: '@?',
            showEpub: '@?',
        },
        template: yourFontsListingTemplate,
        link: function (scope) {
            scope = angular.extend(scope, {
                licenses: {
                    app: [],
                    broadcast: [],
                    desktop: [],
                    epub: [],
                    server: [],
                    game: [],
                    web: [],
                    embedding: [],
                },
                upgradeRenewPopover: $tnPopover.popoverXS(
                    angular.element('.popover-upgrade-renew-licenses'),
                    false
                ),
                showUpgradeRenewPopover: showUpgradeRenewPopover,
                hasNonPerpetualLicense: (l: IDjangoApi1License[]) =>
                    licenseService.hasNonPerpetualLicense(l),
                hasUpgradeableLicense: (l: IDjangoApi1License[]) =>
                    licenseService.hasUpgradeableLicense(l),
                canUpgrade: (l: IDjangoApi1License, t: DjangoLicenseType) =>
                    licenseService.canUpgrade(l, t),
                subsetPopover: $tnPopover.popoverXS(
                    angular.element('.popover-subset-selector'),
                    false
                ),
                showSubsetPopover,
            });
            scope.showApp =
                getPropOrDefault(scope, 'showApp', false).toString() === 'true';
            scope.showEpub =
                getPropOrDefault(scope, 'showEpub', false).toString() ===
                'true';

            if (scope.collection.promise !== undefined) {
                scope.collection.promise.then((results) => {
                    _buildLicenseDict(results);
                });
            } else {
                _buildLicenseDict(scope.collection);

                // Watch for changes when we update the license list via filters etc
                scope.$watchCollection(
                    'collection',
                    (newCollection, oldCollection) => {
                        if (newCollection === oldCollection) {
                            return;
                        }

                        // Clear old licenses
                        Object.keys(scope.licenses).forEach((type) => {
                            scope.licenses[type].splice(
                                0,
                                scope.licenses[type].length
                            );
                        });

                        _buildLicenseDict(scope.collection);
                    }
                );
            }

            function _buildLicenseDict(collection) {
                // Build a dictionary of licenses by type
                Object.keys(scope.licenses).forEach((type) => {
                    scope.licenses[type].push(
                        ...collection.filter(
                            (license) =>
                                license.fontRights[type] &&
                                license.fontRights[type].qty
                        )
                    );
                });
            }

            function showUpgradeRenewPopover($event, licenses, licenseType) {
                if (
                    allAreUnpaid(licenses, licenseType) ||
                    (licenses.length === 1 &&
                        !scope.canUpgrade(licenses[0], licenseType))
                ) {
                    return;
                }
                let popoverLicenses;
                if (!licenseService.hasLimitedLicense(licenses)) {
                    popoverLicenses = hasFurtherUpgrades(licenses, licenseType);
                } else {
                    popoverLicenses = hasBeenPaid(licenses, licenseType);
                    popoverLicenses = hasLimitedQty(
                        popoverLicenses,
                        licenseType
                    );
                }
                angular
                    .element('.popover-upgrade-renew-licenses')
                    .controller()
                    .initialize(null, popoverLicenses, [licenseType]);
                scope.upgradeRenewPopover.show($event.currentTarget);
            }

            function showSubsetPopover($event, licenses, type = 'web') {
                $event.stopPropagation();
                const popoverLicenses =
                    type === 'web'
                        ? hasSelfHostedLicenseList(licenses)
                        : hasLicenseType(licenses, type);
                angular
                    .element('.popover-subset-selector')
                    .controller()
                    .initialize(popoverLicenses, type === 'web');
                scope.subsetPopover.show($event.currentTarget);
                scope.subsetPopover.firstClick = false;
            }
        },
    };
}
